import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AppInitialization} from '@core/services';
import {CompanyStateService} from '@core/states';

export const multiUserGuard: CanActivateFn = async (route, state) => {

  const router = inject(Router);
  const companyState = inject(CompanyStateService);
  const appInitilization = inject(AppInitialization);
  await appInitilization.checkInitialization();
  return companyState.isCompanySelected() || router.parseUrl("/multi-user");
};
